import React from 'react';
import styled from 'styled-components';
import {
    SiFigma,
    SiHtml5,
    SiCss3,
    SiJavascript,
    SiNodedotjs,
    SiAdobephotoshop,
    SiSass,
    SiVisualstudiocode,
} from 'react-icons/si';

const Container = styled.div`
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 2rem;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const ContainerFlex = styled.span`
    display: inline-flex;
    flex-direction: row;
    gap: 1.5rem;
    width: max-content;
    padding: 0 calc(2rem + 1vw);
    font-size: clamp(1.5rem, 2vw, 2.25rem);
`;

const StackUts = () => {
    return (
        <Container className='exp'>
            <ContainerFlex>
                <SiAdobephotoshop size={'1em'} />
                <SiFigma size={'1em'} />
                <SiHtml5 size={'1em'} />
                <SiCss3 size={'1em'} />
                <SiJavascript size={'1em'} />
                <SiNodedotjs size={'1em'} />
                <SiSass size={'1em'} />
                <SiVisualstudiocode size={'1em'} />
            </ContainerFlex>
        </Container>
    );
};

export default StackUts;
